import {getReport, getOtherEventsReport, listEventLogs, exportEventLogs} from "@/services/api/app/dropbox/report";
import {defaultPagination} from "@/services/pagination";

const defaultState = () => ({
  systemEventReports: [],
  otherSystemEventsSummary: [],
  list: [],
  pagination: {
    ...defaultPagination(),
    sortBy: 'startTime',
  },
});

export default {
  namespaced: true,

  actions: {
    list({commit, state}, data) {
      return listEventLogs({
        ...data,
        pagination: state.pagination
      })
        .then(({result, pagination}) => {
          commit('set', result)
          commit('setPagination', pagination)
        })
    },
    export({commit, state}, data) {
      return exportEventLogs(data)
    },
    getReport({commit}, data) {
      return getReport(data)
        .then(report => {
          commit('setSystemEventReport', report);

          return report;
        })
    },
    getOtherEventsSummary({commit}, data) {
      return getOtherEventsReport(data)
        .then(report => {
          commit('setOtherSystemEventsSummary', report);

          return report;
        })
    }
  },

  mutations: {
    set(state, eventLogs) {
      state.list = eventLogs.map(eventLog => ({
        ...eventLog,
        provider: 3
      }));
    },
    setSystemEventReport(state, systemEventReports) {
      state.systemEventReports = systemEventReports
    },
    setOtherSystemEventsSummary(state, otherSystemEventReports) {
      state.otherSystemEventsSummary = otherSystemEventReports
    },
    setPagination(state, pagination) {
      state.pagination = pagination;
    },
    resetPagination(state) {
      state.pagination = {
        ...defaultPagination(),
        sortBy: 'startTime',
      };
    },
  },

  getters: {
    getBackupReports: (state) => () => {
      return state.systemEventReports.find(item => item.type === 1)
    },
    getExportReports: (state) => () => {
      return state.systemEventReports.find(item => item.type === 3)
    },
    getRestoreReports: (state) => () => {
      return state.systemEventReports.find(item => item.type === 2)
    },
    getOtherReports: (state) => () => {
      return state.otherSystemEventsSummary.reduce((acc, item) => {
        return {
          ...acc,
          [`${item.dataType}_${item.actionType}`]: item.actions
        }
      }, {})
    }
  },

  state: defaultState(),

  modules: {},

}
